'use es6';

import { jsxs as _jsxs } from "react/jsx-runtime";
import { jsx as _jsx } from "react/jsx-runtime";
import React, { memo } from 'react';
import FormattedHTMLMessage from 'I18n/components/FormattedHTMLMessage';
import FormattedReactMessage from 'I18n/components/FormattedReactMessage';
import UILink from 'UIComponents/link/UILink';
import { CTA_SECURITY, LanguageCTALinks } from '../../constants/TrialConstants';
import ResultHeaderIllustration from './ResultHeaderIllustration';
import ResultSection from './ResultSection';
import PageScore from '../PageScore';
import Subtitle from '../Subtitle';
import ScoreConstants from '../../constants/ScoreConstants';
import SecurityData from '../../data/SecurityData';
import ResultCtaBanner from '../ResultCtaBanner';
import { parseUtmParams } from '../../util/Urls';
var CTAButton = /*#__PURE__*/memo(function () {
  var lang = window.I18N_MANUAL_LANG;
  var alt = lang !== 'en' ? '-alt' : '';
  var url = lang !== 'en' ? LanguageCTALinks[lang] : CTA_SECURITY;
  var parsedUtmParams = parseUtmParams();
  return /*#__PURE__*/_jsx(UILink, {
    href: url + "&" + parsedUtmParams,
    external: true,
    children: /*#__PURE__*/_jsx(FormattedHTMLMessage, {
      message: "results.security.cta.button" + alt
    })
  });
});
export default (function (_ref) {
  var websiteGrade = _ref.websiteGrade;
  var grade = websiteGrade.get('securityAudit').get('grade');
  return /*#__PURE__*/_jsx("div", {
    className: "full-page-centered security-page",
    id: "security",
    children: /*#__PURE__*/_jsx("div", {
      className: "flex-wrapper",
      children: /*#__PURE__*/_jsxs("div", {
        className: "wsg-container",
        children: [/*#__PURE__*/_jsx(ResultHeaderIllustration, {
          name: "add-on-ssl"
        }), /*#__PURE__*/_jsx(PageScore, {
          score: grade,
          overallScore: ScoreConstants.SECURITY_OVERALL
        }), /*#__PURE__*/_jsx("h3", {
          children: /*#__PURE__*/_jsx(FormattedHTMLMessage, {
            message: "results.security.title"
          })
        }), /*#__PURE__*/_jsx(Subtitle, {
          children: /*#__PURE__*/_jsx(FormattedHTMLMessage, {
            message: "results.security.description"
          })
        }), /*#__PURE__*/_jsx(ResultCtaBanner, {
          use: "lock",
          children: /*#__PURE__*/_jsx(FormattedReactMessage, {
            message: "results.security.cta.info",
            options: {
              ctaButton: /*#__PURE__*/_jsx(CTAButton, {})
            }
          })
        }), /*#__PURE__*/_jsx("div", {
          className: "bg-blob",
          children: /*#__PURE__*/_jsx("div", {
            className: "results-section",
            children: /*#__PURE__*/_jsx(ResultSection, {
              results: SecurityData.results,
              websiteGrade: websiteGrade
            })
          })
        })]
      })
    })
  });
});